import { IntegratorVenue } from "./integrator-venue";
import { License } from "./license.model";

export class Integrator {
	key: string;

	name: string;

	amkDirectBill: boolean;

	licenses: License[];

	integratorVenues: IntegratorVenue[];

	businessIds: string[];

	integrations: string[];

	billings: any;

	public constructor(init?: Partial<Integrator>) {
		Object.assign(this, init);
	}
}
